import { ModelBase } from "@shoothill/core";
import { computed, observable } from "mobx";
import moment from "moment/moment";

export class DailyDiaryQuestionModel extends ModelBase<DailyDiaryQuestionModel, DailyDiaryQuestionModelDTO> {
    public id: string | null = null;
    @observable
    public title: string | null = null;
    @observable
    public ordinal: number = 0;
    @observable
    public completed: boolean = false;
    @observable
    public completedBy: string = "";
    @observable
    public completedByDate: Date | null = null;
    @observable
    public incompleteReason: string = "";

    @computed
    public get formattedCompletedDate(): string {
        return moment(this.completedByDate).format("DD/MM/YYYY @ HH:mm");
    }
    constructor() {
        super();
    }

    fromDto(model: DailyDiaryQuestionModelDTO): void {
        this.id = model.id;
        this.title = model.title;
        this.ordinal = model.ordinal;
        this.completed = model.completed;
        this.completedBy = model.completedBy;
        this.completedByDate = model.completedByDate;
        this.incompleteReason = model.incompleteReason;
    }

    toDto(): DailyDiaryQuestionModelDTO {
        let model: DailyDiaryQuestionModelDTO = {
            id: this.id,
            title: this.title,
            ordinal: this.ordinal,
            completed: this.completed,
            completedBy: this.completedBy,
            completedByDate: this.completedByDate,
            incompleteReason: this.incompleteReason,
        };

        return model;
    }

    @computed
    public get validateIncompleteReason(): string {
        // RULES
        // The reason must be defined if incomplete.

        if (this.completed) {
            return "";
        }

        return this.incompleteReason === "" || this.incompleteReason === null || this.incompleteReason === undefined ? "Please provide a reason" : "";
    }
}

export class DailyDiaryQuestionModelDTO {
    public id: string | null = null;
    public title: string | null = null;
    public ordinal: number = 0;
    public completed: boolean = false;
    public completedBy: string = "";
    public completedByDate: Date | null = null;
    public incompleteReason: string = "";
}
